import type { CardRatingByCardDto } from '@lunary/api-client'
import { REACTIONS } from '@lunary/ui-web/reactions'
import { formatAverage } from './bucket-section'
import styles from '../overview/overview.module.css'

const SOURCE_LABELS: Readonly<Record<string, string>> = { daily: 'Карта дня', pick: 'Выбор 1 из 3' }

export function CardsTable({ cards }: { cards: readonly CardRatingByCardDto[] }) {
  if (cards.length === 0) return null
  return (
    <section className={styles.section} aria-labelledby="cr-cards">
      <h2 id="cr-cards">По картам</h2>
      <div className="card-panel" style={{ overflowX: 'auto' }}>
        <table className="users-table">
          <thead>
            <tr>
              <th>Карта</th>
              <th>Откуда</th>
              <th>Реакций</th>
              <th>Средняя</th>
              {REACTIONS.map((item) => (
                <th key={item.value} title={item.label}>
                  {item.emoji}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {cards.map((card) => (
              <tr key={`${card.source}:${card.card_id}`}>
                <td>{card.card_name}</td>
                <td>{SOURCE_LABELS[card.source] ?? card.source}</td>
                <td>{card.total}</td>
                <td>{formatAverage(card.average)}</td>
                {card.counts.map((count, index) => (
                  <td key={index}>{count}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  )
}
